/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 12/14/14
 * Time: 8:16 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var CP_CONST = require("connection-const");
    var UsageTrackingModel = require("connection-models/UsageTrackingModel");

    var UsageTrackingController = {};
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        UsageTrackingController = Marionette.Controller.extend({

            initialize: function (options) {
                this.connectionPanelContextModel = options.model;
                this.usageToTrackVals = {};
                this.usageToTrackVals.content = _.invert(CP_CONST.USAGE_TO_TRACK.CONTENT);
                this.usageToTrackVals.chat = _.invert(CP_CONST.USAGE_TO_TRACK.CHAT);
                this.usageToTrackVals.search = _.invert(CP_CONST.USAGE_TO_TRACK.SEARCH);
                this.usageToTrackVals.mycases= _.invert(CP_CONST.USAGE_TO_TRACK.MYCASES);
                this.usageToTrackVals.mynotifications= _.invert(CP_CONST.USAGE_TO_TRACK.MY_NOTIFICATIONS);
                this.channel = LEConnection.media.channel(LE.mediaCodes.connection.channels.USAGE_TRACKING) || {vent:{}};
                this._setEventListeners();
            },
            _setEventListeners: function () {
                LEConnection.vent.on("UsageTrackingController:track", this._setTrackEvent, this);
                this.listenTo(this.channel.vent,"UsageTrackingController:track",this._setTrackEvent);
            },
            _setTrackEvent: function (options) {
                if (!this._isTrackEventOptionsValid(options)) {
                    return;
                }
                if (this.usageToTrackVals.content[options.usageToTrack]) {
                    this._setTrackEventToModel(options);
                }
                else if (this.usageToTrackVals.chat[options.usageToTrack]) {
                    this._setTrackEventToModel(options);
                }
                else if (this.usageToTrackVals.search[options.usageToTrack]) {
                    this._setTrackEventToModel(options);
                }
                else if(this.usageToTrackVals.mycases[options.usageToTrack]){
                    this._setTrackEventToModel(options);
                }
                else if(this.usageToTrackVals.mynotifications[options.usageToTrack]){
                    this._setTrackEventToModel(options);
                }
                else{
                    LEConnection.logger.error("UsageTrackingController:track - invalid options.usageToTrack: options.usageToTrack must be in CP_CONST.USAGE_TO_TRACK enum");
                    LEConnection.logger.graph({name:"connection:UsageTrackingController:_setTrackEvent:invalidUsageToTrack"});
                }

            },
            _setTrackEventToModel: function(options){
                if (options.usageToTrack) {
                    this._getUsageTrackingModel().fetch({
                        eventId: options.usageToTrack,
                        slug: options.slug,
                        userId: this.connectionPanelContextModel.get("userId"),
                        persona: this.connectionPanelContextModel.get("persona"),
                        accountId: this.connectionPanelContextModel.get("accountId"),
                        lang: this.connectionPanelContextModel.get("locale"),
                        isTrial: LE.context.get("user.isTrial")
                    });
                    LEConnection.logger.debug("UsageTrackingController:track - successful event track: eventId="+options.usageToTrack+ " eventData="+options.eventData);
                }
                else{
                    LEConnection.logger.error("UsageTrackingController:track - invalid options.eventId: options.eventId is required");
                    LEConnection.logger.graph({name:"connection:UsageTrackingController:_setTrackEventToModel:invalidOptions.eventId"});
                }
            },

            _isTrackEventOptionsValid: function (options) {
                if (!options) {
                    LEConnection.logger.error("UsageTrackingController:track - invalid options: options is must ne an object");
                    LEConnection.logger.graph({name:"connection:UsageTrackingController:_isTrackEventOptionsValid:invalidOptions"});
                    return false;
                }
                if (!options.usageToTrack) {
                    LEConnection.logger.error("UsageTrackingController:track - invalid options.usageToTrack: options.usageToTrack is invalid");
                    LEConnection.logger.graph({name:"connection:UsageTrackingController:_isTrackEventOptionsValid:invalidOptions.usageToTrack"});
                    return false;
                }
                return true;
            },

            _getUsageTrackingModel: function () {
                if (!this.usageTrackingModel){
                    this.usageTrackingModel = new UsageTrackingModel();
                }
                return this.usageTrackingModel;
            }
        });
    });
    return UsageTrackingController;
});


